/* eslint-disable camelcase */
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const subNav = ({ id, title, href, icon, links, ...props }) => {
  const navigate = useNavigate();
  const { isCapacity, isPrepaid } = useSelector((state) => state.auth.user);
  const filteredLinks = links.filter(({ onlyCapacity, onlyPrepaid }) => {
    const matchesFilter = [];
    if (onlyCapacity) {
      matchesFilter.push(onlyCapacity === isCapacity);
    }
    if (onlyPrepaid) {
      matchesFilter.push(onlyPrepaid === isPrepaid);
    }
    return matchesFilter.every(Boolean);
  });
  return {
    navId: id,
    title,
    href,
    icon,
    links: filteredLinks,
    onClick: (e) => {
      e.preventDefault();
      navigate(filteredLinks[0].href);
    },
    ...props,
  };
};
